import AccountSelection from "components/AdvancedLogin/AccountSelection"
import React, { Component } from "react"
import { Container } from "semantic-ui-react"

export default class LoginHandPage extends Component {

  render() {
    return (
      <div className="bg-silver min-vh-100">
        <section className="pt5 pb4">
          <Container >
            <div className="flex justify-center items-center content-center ">
              <AccountSelection to={"/"}/>
            </div>
          </Container>
        </section>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/LoginHandPage.js